import { UserFormType } from 'components';

export const updateUserInitialValues: Partial<UserFormType> = {};
